/**
 * Vakolat tekshiruvi.
 *
 * dev_spec.md §11.2: «barcha permission backenddan». Bu yerda
 * ro'yxat QAYTA YOZILMAYDI — token ichidagi ruxsatlar
 * ishlatiladi.
 *
 * dev_spec.md §12 va AT-029: «UI va API bir xil server siyosatiga
 * tayanadi». Interfeysda tugmani yashirish YETARLI EMAS — server
 * baribir tekshiradi. Bu yerdagi tekshiruv faqat foydalanuvchiga
 * bajarib bo'lmaydigan amalni ko'rsatmaslik uchun.
 */

/** wmskit/rbac katalogidagi nomlar. */
export const PERM = {
  userRead: "identity.user.read",
  userWrite: "identity.user.write",
  roleManage: "identity.role.manage",
  deviceManage: "identity.device.manage",

  masterDataRead: "masterdata.read",
  masterDataWrite: "masterdata.write",
  masterDataImport: "masterdata.import",

  topologyRead: "topology.read",
  topologyWrite: "topology.write",
  topologyImport: "topology.import",

  inventoryRead: "inventory.read",
  inventoryMove: "inventory.move",
  inventoryAdjust: "inventory.adjust",
  blockCreate: "inventory.block.create",
  blockClose: "inventory.block.close",

  taskRead: "task.read",
  taskAssign: "task.assign",
  taskReplan: "task.replan",
  taskCancel: "task.cancel",

  inboundRead: "inbound.read",
  inboundReceive: "inbound.receive",
  inboundArrive: "inbound.arrive",
  inboundApprove: "inbound.discrepancy.approve",

  replenishmentPlan: "replenishment.plan",
  pickingRead: "picking.read",
  pickingExecute: "picking.execute",
  pickingAllocate: "picking.allocate",
  pickingOrderCancel: "picking.order.cancel",

  controlRead: "control.read",
  managerDecision: "control.manager_decision",

  countRead: "count.read",
  countCreate: "count.create",
  countApprove: "count.approve",

  reportRead: "report.read",
  reportExport: "report.export",

  integrationRead: "integration.read",
  integrationRetry: "integration.retry",
  integrationMapping: "integration.mapping.manage",
  integrationReconcile: "integration.reconcile",

  notificationRead: "notification.read",
  notificationManage: "notification.manage",

  mediaRead: "media.read",
  mediaManage: "media.manage",

  auditRead: "audit.read",

  configRead: "config.read",
  configEdit: "config.edit",
  configActivate: "config.activate",
  offsiteRead: "offsite.read",
  offsiteManage: "offsite.manage",
} as const;

export type Permission = (typeof PERM)[keyof typeof PERM];

export function can(permissions: string[], permission: string): boolean {
  return permissions.includes(permission);
}

export function canAny(permissions: string[], required: string[]): boolean {
  return required.some((permission) => permissions.includes(permission));
}
